import IBuildingUses = ZoningAPI.IBuildingUses;
import { ClonableItem } from './clonable-item';

export interface IBuildingUsesModel extends IBuildingUses {
    typeName: string;
}

export class BuildingUse extends ClonableItem<IBuildingUses> implements IBuildingUsesModel {
    CalibrationUsesLabelId: number;
    AllowedUsesId: number;
    TypeId: number;
    TypeName: string;
    TypeNameLabel?: string;
    AllowedUsesLabel: string;
    AllowedUsesName: string;
    AllowedUsesDescription: string;
    CalibrationUsesLabel: string;
    CalibrationUsesDescription: string;

    constructor(value?: IBuildingUses) {
        super(value);
    }

    get typeName() {
        return this.TypeNameLabel || this.TypeName;
    }
}
